import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import './BannerModal.scss';
import Modal from '../../../components/common/Modal';
import { showModal, hideModal } from '../../../actions/modal';
import { getProductsDetails } from '../../../actions/bannerProducts';
import MobileShopThelookModal from './MobileShopThelookModal';
import DesktopShopThelookModal from './DesktopShopThelookModal';
import { getPriceRevealSaleDuration } from '../../../components/common/PriceRevealPLPBanner/priceRevealUtil';
import { signInCheck } from '../../../components/common/CheckUserStatus';
import { loadWishlistOptionCodesAPI } from '../../../wishlist/actions/wishlist';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';
import { getBannerName } from './utils';
import Dialog from '../../molecules/Dialog';

const BannerModal = props => {
  const {
    hideModal,
    variant = 'desktop',
    allBanners = [],
    currentBannerInRow,
    isLuxe,
    displayBannerModal
  } = props;
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
  const [extendedBannerType, setExtendedBannerType] = useState('IMAGE');
  const [videoDetails, setVideoDetails] = useState({
    videoName: '',
    video_load_time: 0,
    isAutoPlayEnabled: false
  });

  const updateVideoDetails = ({
    name,
    loadTime,
    currentIndex
  }: {
    name: string;
    loadTime: number;
    currentIndex: number;
  }) => {
    setVideoDetails({
      videoName: name,
      video_load_time: loadTime,
      isAutoPlayEnabled:
        allBanners[currentIndex - 1]?.dynamicPageMetadata?.videoSettings?.autoPlay || false
    });
  };

  const updateBannerDetails = ({ currentIndex }: { currentIndex: number }) => {
    setCurrentBannerIndex(currentIndex);
    setExtendedBannerType(allBanners[currentIndex]?.dynamicPageMetadata?.mediaType || 'IMAGE');
  };

  const bannerName = getBannerName(allBanners[currentBannerInRow]);
  const closeModal = () => {
    if (extendedBannerType === 'IMAGE') {
      gtmEventPush({
        event: 'shop_the_look',
        event_category: 'Shop the Look',
        event_action: 'Close',
        event_label: bannerName
      });
    } else {
      gtmEventPush({
        event: 'video_screen_interaction',
        event_category: 'shop the look video interactions',
        event_action: 'full screen',
        event_label: 'minimize full screen',
        video_name: videoDetails.videoName,
        is_auto_play_enabled: videoDetails.isAutoPlayEnabled,
        video_load_time: videoDetails.video_load_time,
        store_type: isLuxe ? 'luxe' : 'ajio',
        page_name: 'shop the look video screen',
        page_type: 'shop the look video screen'
      });
      gtmEventPush({
        event: 'video_screen_interactions',
        event_category: 'shop the look video interactions',
        event_action: 'video close',
        video_name: videoDetails.videoName,
        is_auto_play_enabled: videoDetails.isAutoPlayEnabled,
        video_load_time: videoDetails.video_load_time,
        store_type: isLuxe ? 'luxe' : 'ajio',
        page_name: 'shop the look video screen',
        page_type: 'shop the look video screen'
      });
    }
    hideModal('banner-modal');
  };
  const [wishlistOptionCodeUpdates, setWishlistOptionCodeUpdates] = useState(false);

  const loadWishlistDataInCard = () => {
    loadWishlistOptionCodesAPI();
    setTimeout(() => {
      setWishlistOptionCodeUpdates(true);
    }, 2000);
  };

  useEffect(() => {
    hitWishlistOptionCodesAPI();
  }, []);

  const hitWishlistOptionCodesAPI = () => {
    const { username } = props;
    if (!username) return false;
    const wishlistData = JSON.parse(localStorage.getItem('productWishlistStatusData'));
    if (!wishlistData) {
      loadWishlistDataInCard();
    } else {
      const userWishlistData = wishlistData[username];
      if (!userWishlistData) {
        loadWishlistDataInCard();
        return false;
      }
      const { updatedOn = '' } = userWishlistData;
      if (Date.now() - updatedOn >= 86400000) {
        loadWishlistDataInCard();
      }
    }
  };

  if (variant === 'desktop') {
    return (
      <Modal name="banner-modal" className={`${variant}-banner-modal `} show closeButton={false}>
        <div className="close-icon">
          <span role="presentation" className="ic-close-quickview" onClick={closeModal} />
        </div>
        <DesktopShopThelookModal
          {...props}
          updateBannerDetails={updateBannerDetails}
          updateVideoDetails={updateVideoDetails}
        />
      </Modal>
    );
  }
  return (
    <Dialog
      showDialog={displayBannerModal}
      customClass="mobile-banner-modal"
      fullWidth
      type="modal"
      onCancel={closeModal}
    >
      <div className="close-icon">
        <span role="presentation" className="ic-close-quickview" onClick={closeModal} />
      </div>
      <MobileShopThelookModal
        {...props}
        wishlistOptionCodeUpdates={wishlistOptionCodeUpdates}
        updateBannerDetails={updateBannerDetails}
        updateVideoDetails={updateVideoDetails}
      />
    </Dialog>
  );
};

const mapStateToProps = (state, ownProps) => {
  const username = signInCheck(true);
  const modals = state ? state.modals : {};
  const bannerModal = modals ? modals?.['banner-modal'] : {};
  const modalDetails = bannerModal ? bannerModal?.state : {};
  const store = state?.metaData?.name;
  const isLuxe = store === 'luxe';
  const productsData = state?.bannerProducts?.data || {};
  const loading = state?.bannerProducts?.loading || false;
  const priceRevealMetaInfo = state?.bannerProducts?.data?.priceRevealMetaInfo || {};
  const flags = state?.flags;
  const deviceType = state?.request?.deviceType;
  const displayBannerModal = modals ? !!modals['banner-modal'] : false;

  const priceRevealState = getPriceRevealSaleDuration(
    flags,
    deviceType,
    priceRevealMetaInfo,
    store
  );
  return {
    ...modalDetails,
    username,
    isLuxe,
    productsData,
    priceRevealMetaInfo,
    loading,
    priceRevealState,
    currentStore: store,
    displayBannerModal,
    ...ownProps
  };
};

const mapDispatchToProps = {
  showModal,
  hideModal,
  getProductsDetails,
  loadWishlistOptionCodesAPI
};

export default connect(mapStateToProps, mapDispatchToProps)(BannerModal);
